import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import Button from '../shared/Button';
import { cn } from '../../utils/cn';

const inputCls =
  'w-full bg-app-bg border border-app-border rounded-lg px-3 py-2 text-sm text-app-text placeholder:text-app-text-dim focus:ring-2 focus:ring-app-accent/30 focus:border-app-accent outline-none';

type SettingsFormProps = {
  compact?: boolean;
};

export default function SettingsForm({ compact = false }: SettingsFormProps) {
  const { t } = useTranslation();
  const { token, setToken } = useAuth();
  const [apiBase, setApiBase] = useState<string>(() => localStorage.getItem('admin_api_base') || '');
  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    if (apiBase) localStorage.setItem('admin_api_base', apiBase);
    else localStorage.removeItem('admin_api_base');
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className={cn('space-y-4', !compact && 'space-y-5')}>
      <div className={cn(compact && 'space-y-4')}>
        <div>
          <label className="block text-xs font-medium text-app-text mb-1">{t('settings.apiBaseLabel')}</label>
          <p className="text-[11px] text-app-text-dim mb-2 leading-relaxed">{t('settings.apiBaseHintShort')}</p>
          <input
            type="text"
            value={apiBase}
            onChange={(e) => setApiBase(e.target.value)}
            placeholder="http://localhost:81"
            className={inputCls}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-app-text mb-1">{t('settings.tokenLabel')}</label>
          <p className="text-[11px] text-app-text-dim mb-2">{t('settings.tokenHint')}</p>
          <input
            type="password"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder={t('settings.tokenPlaceholder')}
            className={inputCls}
          />
        </div>
      </div>

      <Button onClick={handleSave} variant="primary" size="sm" className="w-full sm:w-auto">
        {saved ? t('common.saved') : t('settings.saveSettings')}
      </Button>

      <p className="text-[11px] text-app-text-dim leading-relaxed border-t border-app-border pt-3">
        {t('settings.persistNoteShort')}
      </p>
    </div>
  );
}
